<template>
  <Layout>
    <Modal
      class="text-lg leading-tight"
      v-model="showModal"
      :backdrop="false"
      :footer="false"
      :header="false"
      :keyboard="false">
      <h1 class="mb-7 text-2xl">No Access</h1>
      <p>
        Our apologies, you don't have permission to view that page. Check with the owner of your team to give you the
        appropriate role for access.
      </p>
      <ButtonPrimary
        v-if="v2DashboardUrl"
        as="a"
        :href="v2DashboardUrl"
        class="mt-7 w-full uppercase">
        My Dashboard
      </ButtonPrimary>
      <ButtonPrimary
        v-else
        :as="RouterLink"
        :to="to"
        class="mt-7 w-full uppercase">
        My Dashboard
      </ButtonPrimary>
    </Modal>
  </Layout>
</template>

<script setup>
import { Modal } from 'uiv';
import Layout from '@/views/_layouts/main.vue';
import ButtonPrimary from '@/components/buttons/ButtonPrimary.vue';
import { RouterLink } from 'vue-router';
import { computed, ref } from 'vue';
import { buildV2DashboardUrl } from '@/utils/v2-links.js';
import { useStore } from 'vuex';

const showModal = ref(true);
const store = useStore();
const team = computed(() => store.state.me.team);
const teamType = computed(() => store.state.me.teamType);
const to = computed(() => {
  if (!team.value?.id) {
    return '/';
  }
  return { name: `${teamType.value}.dashboard.index`, params: { teamId: team.value.id } };
});

// The org dashboard lives in console-v2, so the button leaves v1 for it
const v2DashboardUrl = computed(() => {
  if (!team.value?.id || teamType.value !== 'org') {
    return null;
  }

  return buildV2DashboardUrl({ teamId: team.value.id });
});
</script>
